import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Validators, FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from 'ng-formly';
import { Urls } from '../urls';
import { PlaceholderFieldsService } from '../placeholder-fields.service';
import { Response } from '../response';

@Component({
  selector: 'app-qualify-product',
  templateUrl: './qualify-product.component.html',
  styleUrls: ['./qualify-product.component.css']
})
export class QualifyProductComponent implements OnInit {
  constructor(private http: HttpClient,private urls : Urls, private pFields : PlaceholderFieldsService ) {
   
   }
   form = new FormGroup({});
   forms=[];
   fields = [];
   response ="";
   model = {};
  ngOnInit() : void {
    this.fields = this.pFields.get();
    this.get();
  }
  get() : void 
  {
    this.http.get<Response>(this.urls.forQualifyProductFields()).subscribe(data =>{
      this.fields = data.data;
    });
  }
  set() : void 
  {
    var viewModel = {'viewModel' : this.model};
    this.http.post<Response>(this.urls.forQualifyProductCall(),viewModel).subscribe(data=>{
       this.response = data.data;
    });
  }

 


}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/qualify-product/qualify-product.component.ts